import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

// @ts-expect-error - imported from .js/.jsx file
import {ChatMessageIcon} from 'shells/icon/svg/chat-message-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import {IntercomLaunchButton} from '../../../intercom/intercom-launch-button';

import {LargeTeamMessage} from './large-team-message';
import {SupportStack} from './support-stack';

import styles from './support-section.module.css';

type Props = {
    isNewSubscription: boolean;
    displayLargeTeamMessage: boolean;
};

export function SupportSection(props: Props) {
    return (
        <StackLegacy spacing={16}>
            {props.displayLargeTeamMessage ? <LargeTeamMessage /> : null}
            <SupportStack
                title='Billing support'
                body={
                    <StackLegacy spacing={8}>
                        <Body size='small'>
                            If you have other questions about billing, use our chat services to
                            connect with our team!
                        </Body>
                        <IntercomLaunchButton size='small' variant='secondary' isFullWidth={true}>
                            <div className='flex gap-8 align-center justify-center'>
                                <div className={styles.icon}>
                                    <ChatMessageIcon size={12} alignCenter={true} />
                                </div>
                                <span>Chat with our team</span>
                            </div>
                        </IntercomLaunchButton>
                    </StackLegacy>
                }
            />
            {props.isNewSubscription ? undefined : (
                <SupportStack
                    title='Need to go?'
                    body={
                        <div>
                            <Body size='small'>
                                We want Nutshell to help your business grow. If that’s not
                                happening, let us know, and we can
                            </Body>{' '}
                            <Link
                                // @ts-expect-error
                                as={RoutedLink}
                                to='/setup/billing/cancel'
                                variant='primary'
                                size='small'
                            >
                                close your account
                            </Link>
                            .
                        </div>
                    }
                />
            )}
        </StackLegacy>
    );
}
